import { render, staticRenderFns } from "./MaterialbankNavBar.vue?vue&type=template&id=dc6db4b2&scoped=true&"
import script from "./MaterialbankNavBar.vue?vue&type=script&lang=js&"
export * from "./MaterialbankNavBar.vue?vue&type=script&lang=js&"
import style0 from "./MaterialbankNavBar.vue?vue&type=style&index=0&id=dc6db4b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6db4b2",
  null
  
)

export default component.exports